export const UserSearchMode = Object.freeze({
  AllUsers: 0,
  UsersWithRolesOnly: 1,
  UsersWithoutRolesOnly: 2,
  UsersWithCustomerRolesOnly: 3
})
